import { render, staticRenderFns } from "./Histologia.vue?vue&type=template&id=0f8077d4&scoped=true&"
import script from "./Histologia.vue?vue&type=script&lang=js&"
export * from "./Histologia.vue?vue&type=script&lang=js&"
import style0 from "./Histologia.vue?vue&type=style&index=0&id=0f8077d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8077d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
